import Component from "vue-class-component";
import Vue from "vue";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { PrimoboxExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/PrimoboxExerciceDto";
import dateHelper from "../../../Helper/dateHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { PrimoboxEtatTraitement } from "../../../dto/GenApi.iNotPaie.Dto/PrimoboxEtatTraitement";
import ModalDetailsEnvoiBulletinComponent from "./modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin";
import * as $ from "jquery";
import { primoboxHelper } from "../primoboxHelper";
import { ParametresInstance } from "../../Controls/Parameters";

@Component({
	components: {
		ModalDetailsEnvoiBulletinComponent: require("./modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin.vue.html")
	}
})
export default class EnvoiBulletinsComponent extends Vue {
	public dataReady = false;
	public listYears: number[] = [];
	public selectedYear: number | null = null;

	public primoboxExercices: PrimoboxExerciceDto[] = [];

	public modalDetailsEnvoiBulletinComponent?: ModalDetailsEnvoiBulletinComponent = undefined;

	public mounted(): void {
		EventBus.$on(EventConstants.SOCIETE_CHANGED, this.updateAndGetPrimoboxExercices);
	}

	public activated(): void {
		if (ParametresInstance.societeCourante) {
			this.updateAndGetPrimoboxExercices();
		}
	}

	public formatMoisAnnee(mois: number, annee: number): string {
    	return dateHelper.geLibelleDateMoisAnnee(mois, annee);
	}

	// Met à jour le traitement dans la liste avec les nouvelles données
	public updateTraitement(idExercice: number, newData: PrimoboxExerciceDto): void {
		const index = this.primoboxExercices.findIndex((exercice) => exercice.IdExercice == idExercice);
		if (index !== -1) {
			this.primoboxExercices[index] = newData;
			this.$forceUpdate();
		}
	}

	// Permet d'ouvrir la modal de distribution
	public openModalDistribuer(exercice: PrimoboxExerciceDto): void {
		this.modalDetailsEnvoiBulletinComponent = this.$refs.modalDetailsEnvoiBulletinComponent as ModalDetailsEnvoiBulletinComponent;

		this.modalDetailsEnvoiBulletinComponent.Init(exercice);
		$("#modalDetailsEnvoiBulletinComponent").modal("show");
	}

	// Permet de synchroniser les salariés de l'exercice avec primobox
	public synchroniser(idContrats: number[], onfulfilled?: () => void): void {
		this.dataReady = false;

		NotificationServiceInstance.SendInformation("Début de la synchronisation des salariés.");
		ServicesFactoryInstance.PrimoboxService.synchronizePrimoboxSalaries(idContrats, () => {
			NotificationServiceInstance.SendSuccess("La synchronisation des salariés avec Primobox est terminée.");

			if (onfulfilled) {
				onfulfilled();
			} else {
				this.dataReady = true;
			}
		}, () => {
			this.dataReady = true;
		});
	}

	public synchroniserAndDistribuer(exercice: PrimoboxExerciceDto): void {
		this.dataReady = false;
		this.synchroniser([], () => {
			NotificationServiceInstance.SendInformation("Début de la création du traitement de distribution.");
			ServicesFactoryInstance.PrimoboxService.distributeBulletins(exercice.IdExercice, (data) => {
				this.updateTraitement(exercice.IdExercice, data);
				NotificationServiceInstance.SendSuccess("La distribution des bulletins est en cours de traitement.");
				this.dataReady = true;
			}, () => {
				this.dataReady = true;
			});
		});
	}

	public synchroniserAndRedistribuer(exercice: PrimoboxExerciceDto, idContrats: number[]): void {
		this.dataReady = false;
		this.synchroniser(idContrats, () => {
			NotificationServiceInstance.SendInformation("Début de la création du traitement de redistribution.");
			ServicesFactoryInstance.PrimoboxService.redistributeBulletins(exercice.IdExercice, idContrats,
				(data) => {
					exercice.PossedeRedistribution = true;
					this.updateTraitement(exercice.IdExercice, exercice);
					NotificationServiceInstance.SendSuccess("La redistribution des bulletins est en cours de traitement.");
					this.dataReady = true;
				},
				(error) => {
					this.dataReady = true;
				}
			);
		});
	}

	// Permet de valider l'envoi des bulletins de l'exercice
	public validerDistribution(exercice: PrimoboxExerciceDto): void {
    	if (!exercice || !exercice.IdTraitementExercice) {
    		// L'id de traitement doit être renseigné.
    		NotificationServiceInstance.SendFailed("L'exercice à valider est vide ou n'a pas d'identifiant.");

    		return;
    	}

    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
    		message: "En cliquant sur valider, vous ne pourrez plus modifier la distribution des bulletins.<br><br>Souhaitez-vous continuer ?",
    		title: "CONFIRMATION DE LA DISTRIBUTION",
    		callBackYes: () :void => {
    			this.dataReady = false;
    			ServicesFactoryInstance.PrimoboxService.validerDistribution(exercice.IdTraitementExercice ?? -1, (data) => {
					this.updateTraitement(exercice.IdExercice, data);
    					NotificationServiceInstance.SendSuccess("La validation du traitement a été effectuée.");
    					this.dataReady = true;

    					this.refresh();
    				}, () => {
    					this.dataReady = true;
    				});
			},
			callBackNo: () :void => {
			}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	// Permet de valider une redistribution
	public validerRedistribution(idTraitement?: number): void {
		this.dataReady = false;
		ServicesFactoryInstance.PrimoboxService.validerDistribution(idTraitement ?? -1, () => {
			NotificationServiceInstance.SendSuccess("La validation de la redistribution a été effectuée.");
			this.dataReady = true;
			this.refresh();
		}, () => {
			this.dataReady = true;
		});
	}

	// Permet d'affichage un message lorsqu'on clique sur le lien anomalie
	public messageAnomalie(): void {
		primoboxHelper.messageAnomalie();
	}

	// Bouton rafraichir
	public refresh(): void {
		this.updateAndGetPrimoboxExercices();
	}

	// Conversion des états en libellé
	public convertEtatToString(etat: PrimoboxEtatTraitement): string {
		return primoboxHelper.convertPrimoboxEtatToString(etat);
	}

	// Permet de savoir le style de texte à afficher pour les états
	public canShowSimpleEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowSimpleEtat(etat);
	}

	public canShowAnomalieEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowAnomalieEtat(etat);
	}

	public canShowValiderEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowValiderEtat(etat);
	}

	public canValidate(exercice: PrimoboxExerciceDto): boolean {
    	return exercice && exercice.EstExerciceCloture && exercice.EtatEnum === PrimoboxEtatTraitement.ValidationEnAttente;
	}

	public canDistribute(exercice: PrimoboxExerciceDto): boolean {
    	return exercice && exercice.EstExerciceCloture && exercice.EtatEnum === PrimoboxEtatTraitement.NonDistribue;
	}

	// Permet de savoir si le bouton de distribution doit être affiché. S'il est caché c'est le bouton "Voir le détail"" qui s'affiche
	public canShowButtonDistribuer(etat: PrimoboxEtatTraitement): boolean {
		return etat !== PrimoboxEtatTraitement.Termine;
	}

	/**
	 * Met à jour la liste des exercices Primobox en fonction de l'année sélectionnée.
	 * Si aucune année n'est sélectionnée, récupère d'abord la liste des années disponibles,
	 * sélectionne la première année par défaut, puis charge les exercices correspondants.
	 */
	private updateAndGetPrimoboxExercices(): void {
		this.dataReady = false;

		if (this.selectedYear) {
			this.getPrimoboxExercices();
		} else {
			// Récupère la liste des années disponibles pour Primobox
			ServicesFactoryInstance.PrimoboxService.getPrimoboxFiltersYear((data) => {
				this.listYears = data;
				// Récupére la dernière année disponible ou l'année en cours si aucune donnée n'est disponible
				const max = data.length > 0 ? Math.max(...data) : new Date().getFullYear();
				this.selectedYear = max;
				this.getPrimoboxExercices();
			}, () => {
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de la liste des années d'utilisation de Primobox");
				this.dataReady = true;
			});
		}
	}

	/**
	 * Récupère la liste des exercices Primobox pour l'année sélectionnée.
	 * Met à jour la propriété primoboxExercices avec les données récupérées.
	 */
	private getPrimoboxExercices(): void {
		if (this.selectedYear != null) {
			this.dataReady = false;

			// Met à jour les exercices Primobox pour l'année sélectionnée
			ServicesFactoryInstance.PrimoboxService.updatePrimoboxExercices({ idExercice: undefined, year: this.selectedYear }, () => {
				// Récupère les exercices après la mise à jour
				ServicesFactoryInstance.PrimoboxService.getPrimoboxExercices(this.selectedYear as number, (data) => {
					this.primoboxExercices = data;
					this.dataReady = true;
				}, () => {
					NotificationServiceInstance.SendFailed(`Une erreur est survenue lors de la récupération des informations Primobox pour l'année ${this.selectedYear}`);
					this.primoboxExercices = [];
					this.dataReady = true;
				});
			}, () => {
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la mise à jour de l'exercice");
				this.dataReady = true;
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/Primobox/envoiBulletins/envoiBulletins.ts